const scolAreaChart = {
  scol: {
    chart: {
      id: "vuechart-example",
    },

    chart: {
      type: "bar",
      fontFamily: "Poppins, sans-serif",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        endingShape: "rounded",
      },
    },
    colors: ["#3865b0", "#fbc83f"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      title: {
        text: "$ (thousands)",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "$ " + val + " thousands";
        },
      },
    },
  },
  series: [
    {
      name: "Received",
      type: "column",
      data: [],
    },
    {
      name: "Due",
      type: "column",
      data: [],
    },
  ],
};

const donutAreaCharts = {
  donutchart: {
    chart: {
      id: "vuechart-example",
    },
    chart: {
      fontFamily: "Poppins, sans-serif",
      height: 350,
      type: "donut",
    },
  },
  labels: [],
  legend: { show: false },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: "bottom",
        },
      },
    },
  ],
  colors: ["#ff737b", "#7638ff ", "#1ec1b0"],
  series: [],
};
const getDataForBarChart = (data) => {
  scolAreaChart.scol.xaxis.categories = [];
  scolAreaChart.series[0].data = [];
  scolAreaChart.series[1].data = [];
  for (const key in data.data) {
    const details = data.data[key];
    scolAreaChart.scol.xaxis.categories.push(key);
    scolAreaChart.series[0].data.push(details.paid);
    scolAreaChart.series[1].data.push(details.due);
  }
};
const getDataForDonutChart = (data) => {
  donutAreaCharts.series = [];
  donutAreaCharts.labels = [];
  donutAreaCharts.colors = [];
  for (const key in data) {
    const value = data[key];
    if (key == "expenses") {
      //   donutAreaCharts.colors.push("#ff737b");
      donutAreaCharts.series.push(value);
    }
    if (key == "total") {
      //   donutAreaCharts.colors.push("#7638ff");
      donutAreaCharts.series.push(value);
    }
    if (key == "paid") {
      //   donutAreaCharts.colors.push("#1ec1b0");
      donutAreaCharts.series.push(value);
    }
  }
};
export {
  scolAreaChart,
  donutAreaCharts,
  getDataForBarChart,
  getDataForDonutChart,
};
